<script>
    import guff from "dataset:../_data/guff.aml";
	import { onMount } from 'svelte';
    import {scaleLinear} from "d3-scale";
    export let assets;
    let y;
    let height;

    $: interpolate = scaleLinear()
        .domain([0, height * 0.2])
        .range([20, 95])

    $: width_interpolated = Math.min(interpolate(y), 120);

    onMount(async () => {
        setTimeout(() => {
            document.getElementById("header-content").style.opacity = 1;
            document.getElementById("dirt-wrapper").style.opacity = 1;
        }, 100);
    })


</script>
    <svelte:window bind:scrollY={y} bind:innerHeight={height}/>

    <!-- <mark>{y}, {height}, {width_interpolated} </mark> -->

    <div class="lawn">
        <div class="lawn-texture" style="background-image: url({assets[0]})"></div>
        <header class="center wide-md">
            <div class="header-content" id="header-content">
                <div id="opener__hed_wrapper">
                    <h1 class="opener__hed" id="opener__hed_bkgd"> { @html guff.hed_text }</h1>
                    <h1 class="opener__hed" id="opener__hed_fgd"> { @html guff.hed_text }</h1>
                </div>
                <div class="article-meta-1__pubdate" style="text-align: center;">
                    <time datetime="{ guff.pubdate }">{ guff.pubdate_text }</time>
                </div>
            </div> <!-- end .header-content -->
        </header>

        <div id="dirt-wrapper" style="width:{width_interpolated}%;">
            <div class="dirt-texture" style="background-image: url({assets[1]})"></div>
            <div class="dirt-edge"></div>
            <div class="dirt-roll">
                <div class="dirt-circle">
                    <div class="dirt-circle-1"></div>
                    <div class="dirt-circle-2"></div>
                </div>
            </div>
        </div>

        <div class="sidewalk-wrapper">
            {#each {length: 5} as _, i}
                <div class="sidewalk-two-wrapper">
                    <div class="sidewalk-two">
                        <div class="sidewalk-one-wrapper">
                            <div class="sidewalk-one"></div>
                        </div>
                        <div class="sidewalk-two-trim"></div>
                    </div>
                    <div class="sidewalk-two-edge"></div>
                </div>
            {/each}
        </div>
    </div>
            
<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";
    mark {
        padding: 0.5em;
        position: fixed;
        bottom: 0;
        right: 0;
    }
    header {
        margin-top: 1svh !important;
        height: 80svh;
        display: flex;
        align-items: center;
        justify-content: center;;

        @include breakpoint-max(lg) {
            margin-top: 5svh !important;
        }

        #header-content {
            opacity: 0;
            transition: opacity 0.6s
        }

        #opener__hed_wrapper {
            min-width: 300px;
            max-width: 550px;
            margin: 0 auto;
            padding-top: 6svh;
            position: relative;

            @include breakpoint-max(lg) {
                max-width: 500px;
                padding: 0 var(--spacing-1);
            }
            @include breakpoint-max(md) {
                max-width: 480px;
            }

            @include breakpoint-max(sm) {
                max-width: 380px;
            }

            .opener__hed {
                font-size: var(--scale6);
                text-align: center;
                font-family: var(--fonts-sans);
                font-weight: 900;
                color: white;
                background-color: var(--color-lawn);

                @include breakpoint-max(sm) {
                    font-size: var(--scale4);
                }
            }
        
            #opener__hed_bkgd {
                position: absolute;
                -webkit-text-stroke: var(--intro-stroke-width) #000;

                @include breakpoint-max(md) {
                    -webkit-text-stroke-width: var(--intro-stroke-width-mobile);
                }
            }
        }
    }

    .article-meta-1__pubdate {
        color: #000;

        @include breakpoint-min(lg) {
            font-size: var(--scale-1);
        }
    }

    .lawn {
        background-color: var(--color-lawn);
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
        z-index: -10;
        
        .lawn-texture {
            width: 100%;
            height: 100%;
            position: absolute;
            background-size: 1366px 768px;
            background-position: center center;
            z-index: -8;

            @include breakpoint-max(md) {
                background-size: 900px;
            }
        }
    }

    
    #dirt-wrapper {
        position: absolute;
        z-index: -5;
        background-color: var(--color-dirt);
        height: calc(var(--color-intro-sidewalk-height) * 0.95 * 0.85);
        bottom: var(--color-intro-sidewalk-height);
        border-top: var(--intro-stroke);
        width: 20%;
        transition: width 0.4s, opacity 0.2s;
        transition-timing-function: ease;
        opacity: 0;

        .dirt-texture {
            width: 100%;
            height: 100%;
            position: absolute;
            background-size: 1366px 150px;
            background-position: left center;
            background-attachment: local;
            z-index: -8;
            
            @include breakpoint-max(md) {
                background-size: cover;
            }
        }

        .dirt-edge {
            background-color: var(--color-dirt-dark);
            border-bottom: var(--intro-stroke);
            width: 100%;
            height: 0.4vw;
            min-height: 6px;
            position: absolute;
            top: 0;
        }

        .dirt-roll {
            position: absolute;
            width: 2.5vw;
            min-width: 40px;
            top: min(-1.25vw, -20px);
            right: min(-1.25vw, -20px);;
            height: 100%;
            border-top-right-radius: 100px;
            border-top-left-radius: 100px;
            background-color: var(--color-dirt);
            border: var(--intro-stroke);
            
            .dirt-circle {
                width: calc(100% + 2px);
                aspect-ratio: 1 / 1;
                border-radius: 100px;
                border: var(--intro-stroke);
                background-color: var(--color-dirt);
                position: absolute;
                bottom: calc(min(-1.25vw, -20px) - 2px);
                left: -1px;

                .dirt-circle-1 {
                    width: 75%;
                    aspect-ratio: 1 / 1;
                    border-radius: 100%;
                    background-color: var(--color-lawn);
                    border: var(--intro-stroke);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                .dirt-circle-2 {
                    width: 50%;
                    aspect-ratio: 1 / 1;
                    border-radius: 100%;
                    background-color: var(--color-dirt);
                    border: var(--intro-stroke);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .sidewalk-wrapper {
        position: absolute;
        z-index: -5;
        background-color: var(--color-sidewalk-dark);
        height: var(--color-intro-sidewalk-height);
        width: 100%;
        bottom: 0;
        display: flex;
        align-items: center;
        border-bottom: var(--intro-stroke);
        overflow: hidden;

        .sidewalk-two-wrapper {
            display: inline-block;
            width: 30%;
            min-width: 30svh;
            height: 100%;
        }
        .sidewalk-two {
            width: 100%;
            height: 95%;
            background-color: var(--color-sidewalk);
            border-top: var(--intro-stroke);
            border-bottom: var(--intro-stroke);
            border-right: var(--intro-stroke);
            .sidewalk-one-wrapper {
                height: 85%;
                .sidewalk-one {
                    display: inline-block;
                    width: calc(50% - 2px);
                    height: 100%;
                    border-right: var(--intro-stroke);
                }
            } 

            .sidewalk-two-trim {
                height: 15%;
                border-top: var(--intro-stroke);
            }        
        }
        .sidewalk-two-edge {
            width: 100%;
            height: 5%;
            border-right: var(--intro-stroke);
            position: relative;
            left: -2.5px;
            background-color: var(--color-sidewalk-dark);
            transform: skewX(-40deg);
        }
    }

</style>